module.exports = __webpack_public_path__ + "static/img/btn.3f310d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/btn.svg
// module id = aDH4
// module chunks = 0